import Button from '../Button';
import styles from './FilterDropdown.module.scss';
import cn from 'clsx';
import CollapseVacancy from '../CollapseVacancy/CollapseVacancy';
import Checkbox from '../Checkbox';
import Dropdown from '../Dropdown';

export const FilterDropdown = ({
  apply,
  reset,
  sections,
  currentQueries,
  count,
  inputCallback,
  className,
}) => {
  return (
    <Dropdown buttonContent="Фильтры" count={count}>
      <div className={cn(styles.filterDropdown, className)}>
        <div className={styles.sections}>
          {sections.map(({ key, title, items }) => (
            <div key={key}>
              {title && <div className={styles.title}>{title}</div>}
              <div className={styles.collapse}>
                <CollapseVacancy
                  filterType={key}
                  size="small"
                  count={4}
                  data={items.map((item) => (
                    <div className={styles.checkbox} key={item.id}>
                      <Checkbox
                        section={key}
                        id={item.id}
                        value={item.name}
                        type={key === 'experience' ? 'radio' : null}
                        inputCallback={inputCallback}
                        checkedStatus={
                          currentQueries?.[key]?.includes(item.id) || false
                        }
                      />
                    </div>
                  ))}
                  toggler="Показать все"
                />
              </div>
            </div>
          ))}
        </div>

        <div className={styles.actions}>
          <Button onClick={apply} design="green">
            Применить
          </Button>
          <Button onClick={reset} design="green-outline">
            Сбросить
          </Button>
        </div>
      </div>
    </Dropdown>
  );
};
